// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_fO","advertDetailService__price":"c-o_fP"};